import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "constants";

export const xmlExportApi = createApi({
  reducerPath: "xmlExportApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_URL}/v2`,
  }),
  tagTypes: ["XmlExport"],
  endpoints: (builder) => ({
    // Export Scenes to XML
    exportScenesToXml: builder.mutation({
      query: ({ token, exportData }) => ({
        url: `/${token}/xml/export`,
        method: "POST",
        body: exportData,
      }),
      responseHandler: (response) => response.blob(),
    }),

    // Preview XML Export
    previewXmlExport: builder.query({
      query: (token) => `/${token}/xml/preview`,
      providesTags: ["XmlExport"],
    }),
  }),
});

export const {
  useExportScenesToXmlMutation,
  usePreviewXmlExportQuery,
} = xmlExportApi;

export default xmlExportApi;
